import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import orm from '../../../orm';

export function* fetchCardPointDataInCurrentCard() {
  const card = yield select(selectors.selectCurrentCard);
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!card || !pointSystem) {
    return;
  }

  yield put(actions.fetchCardPointData(card.id));

  let item;
  try {
    ({ item } = yield call(request, api.getCardPointData, card.id));
  } catch (error) {
    yield put(actions.fetchCardPointData.failure(card.id, error));
    return;
  }

  yield put(actions.fetchCardPointData.success(card.id, pointSystem.id, item || null));
}

export function* upsertCardPointDataInCurrentCard(data) {
  const card = yield select(selectors.selectCurrentCard);
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!card || !pointSystem) {
    return;
  }

  yield put(actions.upsertCardPointData(card.id, data));

  let item;
  try {
    ({ item } = yield call(request, api.upsertCardPointData, card.id, data));
  } catch (error) {
    yield put(actions.upsertCardPointData.failure(card.id, error));
    return;
  }

  yield put(actions.upsertCardPointData.success(item));
}

export function* completeCardPointDataInCurrentCard(taskClosedAt) {
  const card = yield select(selectors.selectCurrentCard);
  const pointSystemBefore = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!card) {
    return;
  }

  yield put(actions.completeCardPointData(card.id));

  let item;
  let archivedItem;
  try {
    ({ item, archivedItem } = yield call(request, api.completeCardPointData, card.id, taskClosedAt));
  } catch (error) {
    yield put(actions.completeCardPointData.failure(card.id, error));
    return;
  }

  yield put(actions.completeCardPointData.success(item, archivedItem || null));

  // Если система баллов для доски ещё не заведена (PointSystem отсутствует в ORM),
  // эндпоинт complete на бэке может создать PointSystem "лениво". В этом случае
  // `CardModalContainer` не знает `pointSystemId`, и `cardPointData` не находится селекторами —
  // визуально выглядит как "ничего не произошло".
  //
  // Здесь подстраховываемся: добавляем PointSystem в store на основе ответа complete.
  if (!pointSystemBefore && item?.pointSistemId && card?.boardId) {
    yield put(
      actions.updatePointSystem.success({
        id: item.pointSistemId,
        boardId: card.boardId,
        isEnabled: false,
      }),
    );
  }
}

export function* uncompleteCardPointDataInCurrentCard() {
  const card = yield select(selectors.selectCurrentCard);
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!card || !pointSystem) {
    return;
  }

  // Находим archivedItem до удаления
  const state = yield select();
  const db = orm.session(state.orm);
  const cardPointData = db.CardPointData.all()
    .filter({ cardId: card.id, pointSistemId: pointSystem.id })
    .first();
  
  let archivedItem = null;
  if (cardPointData) {
    const archivedData = db.CardPointArchivedData.all()
      .filter({ cpdId: cardPointData.id })
      .first();
    if (archivedData) {
      archivedItem = archivedData.ref;
    }
  }

  yield put(actions.uncompleteCardPointData(card.id));

  let item;
  try {
    ({ item } = yield call(request, api.uncompleteCardPointData, card.id));
  } catch (error) {
    yield put(actions.uncompleteCardPointData.failure(card.id, error));
    return;
  }

  yield put(actions.uncompleteCardPointData.success(item));
  
  // Отправляем action для удаления archivedItem из store
  if (archivedItem) {
    yield put({
      type: 'CARD_POINT_ARCHIVED_DATA_DELETE__SUCCESS',
      payload: {
        archivedItem,
      },
    });
  }
}

export default {
  fetchCardPointDataInCurrentCard,
  upsertCardPointDataInCurrentCard,
  completeCardPointDataInCurrentCard,
  uncompleteCardPointDataInCurrentCard,
};

